import { useEffect, useState, useRef } from 'react'
import { Form } from '@/ui'
import ErrorLabel from './ErrorLabel'

interface FieldColorProps {
  input: any
  value?: any
  fieldError?: boolean
  onChange?: () => void
  label?: string
  touched?: boolean
  error?: string
  title?: string
  labelText?: string
  description?: string
}

function componentToHex(c = 0) {
  const hex = c.toString(16)
  return hex.length == 1 ? '0' + hex : hex
}

function rgbToHex(rgb: string) {
  const [r, g, b] = rgb
    .replace('rgb(', '')
    .replace(')', '')
    .split(',')
    .map(v => parseInt(v))
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
}

const FieldColor = ({
  value,
  label,
  input,
  touched,
  error,
  title,
  description,
}: FieldColorProps) => {
  const [color, setColor] = useState(
    input?.value?.color || value?.color || input.value || value,
  )

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    setColor(input?.value?.color || value?.color || input.value || value)
  }, [value, input.value])

  const handleColorChange = (e: any) => {
    input.onChange(e.target.value)
  }

  useEffect(() => {
    if (!inputRef.current) {
      return
    }

    inputRef.current.addEventListener('change', handleColorChange)

    return () => {
      inputRef.current?.removeEventListener('change', handleColorChange)
    }
  }, [inputRef])

  return (
    <Form.Field title={title}>
      {label}

      {description && <div>{description}</div>}

      <div>
        <input
          ref={inputRef}
          type="color"
          value={color.startsWith('rgb') ? rgbToHex(color) : color}
          onChange={e => {
            setColor(e.target.value)
          }}
        />
        {touched && error && error.length && <ErrorLabel error={error} />}
      </div>
    </Form.Field>
  )
}

export default FieldColor
